export const CONFIRM_CANCEL_RESERVATION = 'Are you sure you want to cancel?';
